export default {
  roles: [],
  accessToken: '',
  error: {
    errorCode: 'failed_to_initialize',
    message: 'Failed to Initialize: Default State'
  },

  uid: '',
  name: '',
  email: '',
  picture: ''
}
